module.exports = __webpack_public_path__ + "img/frepap.a3e4500e.png";